import React, { useEffect, useState } from 'react';

import { Box, CircularProgress, Stack, Typography } from '@mui/material';

type Props = {
  goalDate: Date;
};
export default function CountdownTimer({ goalDate }: Props) {
  const calculateTimeLeft = () => {
    return goalDate.getTime() - new Date().getTime();
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 500);
    return () => {
      clearInterval(interval);
    };
  });

  const days = timeLeft < 0 ? 0 : Math.floor(timeLeft / (1000 * 60 * 60 * 24));
  const hours = timeLeft < 0 ? 0 : Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
  const minutes = timeLeft < 0 ? 0 : Math.floor((timeLeft / 1000 / 60) % 60);
  const seconds = timeLeft < 0 ? 0 : Math.floor((timeLeft / 1000) % 60);

  if (timeLeft <= 0) {
    return (
      <Stack direction="row" spacing={1} alignItems="center" sx={{ p: 2 }}>
        <CircularProgress size={16} />
        <Typography color="text.secondary">Processing &hellip;</Typography>
      </Stack>
    );
  }
  return (
    <Box sx={{ p: 2 }}>
      <Typography color="text.secondary">Continuing workflow in &hellip;</Typography>
      <Stack direction="row" spacing={2} justifyContent="space-around" sx={{ mt: 2, mb: 1 }}>
        <Stack spacing={0.5} alignItems="center">
          <Typography variant="h5">{days}</Typography>
          <Typography variant="body2" color="text.secondary">
            Days
          </Typography>
        </Stack>

        <Stack spacing={0.5} alignItems="center">
          <Typography variant="h5">{hours}</Typography>
          <Typography variant="body2" color="text.secondary">
            Hours
          </Typography>
        </Stack>

        <Stack spacing={0.5} alignItems="center">
          <Typography variant="h5">{minutes}</Typography>
          <Typography variant="body2" color="text.secondary">
            Minutes
          </Typography>
        </Stack>

        <Stack spacing={0.5} alignItems="center">
          <Typography variant="h5">{seconds}</Typography>
          <Typography variant="body2" color="text.secondary">
            Seconds
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
}
